// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue'
import { firestore } from 'firebase'
import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators'
import { firestoreAction } from 'vuexfire'
import { db } from '../../firebase/init'
import { TaskType } from '../../types'
import store from '..'


@Module({ name: 'tasksStore', store, dynamic: true })
export default class TasksStore extends VuexModule {
  // allTasks:TaskType[] = []
  allTasks:TaskType[] = [
    {
      details: 'Example Task 1',
      employee: 'chris@canvasrestaurantconsultants_com',
      task: 'Do XXX',
      completed: null,
      shift: false,
      due: '2020-01-27',
      completedBy: 'chris@canvasrestaurantconsultants_com',
      location: 'cobbswoodstock',
      created: new Date('2020-01-28T02:18:07.802Z'),
      comments: [],
    }]

  bound = false

  @Mutation
  setBound(bind:boolean = true) {
    this.bound = bind
  }

  get employeeTasks() {
    if (!store.state.user || !store.state.user.auth) return []
    return this.allTasks
    // return this.allTasks.filter(t => t.employee === store.state.user.auth.id)
  }

  get numberEmployeeTasks() {
    const total = this.employeeTasks.length
    const done = this.employeeTasks.filter((task:TaskType) => task.completed !== null).length
    return {
      total,
      done,
      complete: total === done,
    }
  }

  get tasksDue() {
    return this.allTasks.filter(task => task.completed === null)
  }

  @Action
  bindTasks() {
    console.log('now binding tasks of: user')
    const Tasks = firestoreAction(({ bindFirestoreRef }) => bindFirestoreRef('allTasks', db.collection('tasks').where('employee', '==', store.state.user.auth.id))) as Function
    return Promise.all([Tasks(this.context)])
  }
}

// // ,
// const locationBoards = firestoreAction(({ bindFirestoreRef }) => bindFirestoreRef('data', db.collection('infoBoards').where('location', '==', store.getters.location))) as Function
// const groupBoards = firestoreAction(({ bindFirestoreRef }) => bindFirestoreRef('groupData', db.collection('infoBoards').where('group', '==', store.getters.group))) as Function
